/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import { literal } from '../../util.type';

// TODO: Otázka, zda používat literal, protože pak lze zadat jako parametr funkcí
// i string např. `'Warning'`, což je ale spíše nechtěné.
/**
 * Úroveň důležitosti chyby.
 * Vychází z úrovní zavedených v Console API pod pojmenováním `logLevel`.
 * Úrovně mají následující prioritu:
 * `Error` > `Warning` > `Info` > `Log` > `Debug`.
 *
 * Zdroje:
 * - [Console API](https://console.spec.whatwg.org/)
 * @enum {'Debug' | 'Error' | 'Info' | 'Log' | 'Warning'}
 * @readonly
 */
const ErrorLevel = {
  /** Verbose debug log which is usually hidden by default. */
  Debug: literal('Debug'),
  /** Critical error which can lead to an unexpected bahaviour or a crash. */
  Error: literal('Error'),
  /** Informative log with a slightly higher than low significance. */
  Info: literal('Info'),
  /** Common log with a low significance. */
  Log: literal('Log'),
  /** Warning about an unusual state which won't affect the script execution. */
  Warning: literal('Warning')
};

export default ErrorLevel;
